// extracted by mini-css-extract-plugin
export default {"substatus-name":"search-substatus_substatus-name__y6pDY","selected-substatus":"search-substatus_selected-substatus__lM6Ke","status-icon":"search-substatus_status-icon__Vywzq"};